
import Initiatives from '../components/Initiatives';
import PageHeader from "../components/PageHeader";

export default function Events() {
    return (
	<>
	    <PageHeader title="संस्थान" path="/event" name="Events" />
	    <Initiatives />
	</>
    );
}